<template>
  <stock-list :is-stock-status="0"></stock-list>
</template>

<script>
import StockList from './components/StockList'
export default {
  name: 'AllStock',
  components: {
    StockList
  }
}
</script>
